const UPDATE_ANALYSE_RESPONSE = {
  Result: 'Result',
  TokenError: 'TokenError',
  WrongInputs: 'WrongInputs',
  Unauthorized: 'Unauthorized',
};

export default UPDATE_ANALYSE_RESPONSE;
